"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var MenuContext_1 = require("./MenuContext");
var MenuHead_1 = require("./MenuHead");
var MenuBody_1 = require("./MenuBody");
var MenuSlider = function (_a) {
    var menus = _a.menus, open = _a.open, handleSlide = _a.handleSlide;
    var _b = (0, hooks_1.useState)(null), subMenu = _b[0], setSubMenu = _b[1];
    var contextValue = {
        setSubMenu: setSubMenu,
        handleSlide: handleSlide,
    };
    if (window.sessionStorage.getItem('desktop-nav-hover-test')) {
        return ((0, preact_1.h)(MenuContext_1.default.Provider, { value: contextValue },
            (0, preact_1.h)("div", { onMouseLeave: function () { return handleSlide(null); }, class: "menu-slider ".concat(open ? 'menu-slider--open' : '') },
                (0, preact_1.h)(MenuHead_1.default, { subMenu: subMenu }),
                (0, preact_1.h)(MenuBody_1.default, { subMenu: subMenu, menus: menus }))));
    }
    else {
        return ((0, preact_1.h)(MenuContext_1.default.Provider, { value: contextValue },
            (0, preact_1.h)("div", { class: "menu-slider ".concat(open ? 'menu-slider--open' : '') },
                (0, preact_1.h)(MenuHead_1.default, { subMenu: subMenu }),
                (0, preact_1.h)(MenuBody_1.default, { subMenu: subMenu, menus: menus }))));
    }
};
exports.default = MenuSlider;
